/**
 * A vertical menu (docs/spec/04 §6): white items, the selected one yellow with a marker beside it -
 * the Lancer nosing up to it, or a pair of arrows. Also the game's pause menu.
 */

import { textWidth } from '../../render/font';
import type { Screen } from '../../render/screen';
import { drawSprite } from '../../render/sprites';
import { nudge } from './chrome';
import type { ListLayout, MenuItem } from './menuModel';
import { slideOffset } from './menuModel';
import { FAINT, INK, SELECTED } from './theme';

export interface MenuLook extends ListLayout {
  /** Centre of the labels. */
  readonly cx: number;
  /** Fill each row's hit area with black first (a menu over a busy picture). */
  readonly plate?: boolean;
  /** Slide items in from the sides over the first moments after `ms` 0. */
  readonly slide?: boolean;
  /** What points at the selected item (default the arrows). */
  readonly marker?: 'ship' | 'arrows';
}

/** Draw `items` with `sel` selected; `ms` drives the slide-in and the marker. */
export function drawMenu(screen: Screen, items: readonly MenuItem[], sel: number, look: MenuLook, ms: number): void {
  items.forEach((item, i) => {
    const y = look.top + i * look.rowH;
    if (look.plate === true) {
      const pad = Math.floor((look.rowH - 8) / 2);
      screen.fill(look.x, y - pad, look.w, look.rowH, 0);
    }
    const dx = look.slide === true ? (i % 2 === 0 ? -1 : 1) * slideOffset(i, ms) : 0;
    const on = i === sel;
    const colour = item.disabled === true ? FAINT : on ? SELECTED : INK;
    screen.text(item.label, look.cx + dx, y, colour, 'center');
    if (!on || dx !== 0) return;
    const half = Math.ceil(textWidth(item.label) / 2);
    const push = nudge(ms);
    if (look.marker === 'ship') {
      // Heading 0 is east: the ship points at its item.
      drawSprite(screen, 'lancer', 0, look.cx - half - 16 + push, y + 3, 0);
    } else {
      screen.text('►', look.cx - half - 14 + push, y, SELECTED);
      screen.text('◄', look.cx + half + 6 - push, y, SELECTED);
    }
  });
}
